import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import 'Components/Vouchers/VoucherBadge.scss';

export default function VoucherBadge({ newsletter }) {
  if (!newsletter) return <React.Fragment />;

  return (
    <div className="VoucherBadge">
      <div className="VoucherBadge_Container">
        <div className="VoucherBadge__label-slash" />
        <div className="VoucherBadge_label-content">
          <FormattedMessage id="voucher-badge.subscribe" defaultMessage="Email Subscribers" />
        </div>
      </div>
    </div>
  );
}

VoucherBadge.propTypes = {
  newsletter: PropTypes.bool,
};

VoucherBadge.defaultProps = {
  newsletter: false,
};
